import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useToast } from "../../components/shared/ToastProvider";
import latestLogo from "../../assets/latestLogo.svg";
import { api } from "../../utils/api";
import SupportSidebarSetPassword from "../SetPassword/SupportSidebarSetPassword";
import { FaArrowLeftLong } from "react-icons/fa6";
import { useTranslation } from "react-i18next";
import { API_ROUTES } from "../../routes/apiRoutes";
import { LanguageDropdown } from "../../components/shared/LanguageDropdown";

export default function ForgetPassword() {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const { addToast } = useToast();
  const { i18n } = useTranslation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await api({
        method: "POST",
        url: API_ROUTES.FORGET_PASSWORD,
        data: { email },
      });
      addToast("Password reset link sent to your email.", "success");
      setTimeout(() => {
        navigate("/login");
      }, 1200);
    } catch (error) {
      addToast(
        error?.response?.data?.message || "Failed to send reset link.",
        "error",
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="h-screen flex bg-[#F6FBFF] ">
      <div className="hidden md:flex flex-col mt-[20px]">
        <SupportSidebarSetPassword />
      </div>
      <div className="flex-1 flex flex-col">
        <div className="w-full px-4 flex items-center justify-end">
          <div className="flex items-center space-x-2 m-4 w-max">
            <div className="flex items-center space-x-2">
              <a
                href="/login"
                className="h-9 flex-none px-3 bg-[#F6FBFF] text-gray-600 border border-gray-300 rounded-lg text-base flex items-center gap-2"
              >
                <FaArrowLeftLong className="inline-block mr-1" />
                {i18n.language == "en" ? "Go Back" : "Gå tilbage"}
              </a>

              <LanguageDropdown />
            </div>
          </div>
        </div>
        <div className="flex-1 flex items-center justify-center px-4 overflow-hidden">
          <div className="w-full max-w-lg flex flex-col justify-center gap-2">
            <div className="text-center">
              <div className="font-sans p-1 rounded-sm flex justify-center items-center">
                <img
                  src={latestLogo}
                  alt="AssetEye Logo"
                  className="w-12 h-12"
                />
              </div>
              <h1 className="text-xl font-bold text-black mb-1 tracking-tight">
                {i18n.language == "en" ? "Forgot" : "Glemt"}{" "}
                <span className="text-[#3D6C50]">
                  {i18n.language == "en" ? "Password" : "Adgangskode"}
                </span>
              </h1>
              <p className="text-gray-600 mb-2 text-xs">
                {i18n.language === "en" ? (
                  "Enter your registered email to receive a password reset link."
                ) : (
                  <>
                    Indtast din registrerede e-mailadresse for at modtage et
                    link til <br /> nulstilling af adgangskode.
                  </>
                )}
              </p>
            </div>
            <form onSubmit={handleSubmit} className="space-y-4 px-6">
              <div>
                <label className="block text-sm font-sm text-gray-700 mb-2">
                  {i18n.language == "en" ? "Email Address" : "E-mail adresse"}
                </label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full bg-[#F1F6F9] text-sm py-2 px-4 border border-gray-300 rounded-lg focus:outline-none focus:border-[#2E6243]"
                  placeholder={
                    i18n.language == "en"
                      ? "Enter your email"
                      : "Indtast din e-mail"
                  }
                  required
                />
              </div>
              <button
                type="submit"
                disabled={!email || isSubmitting}
                className="w-full text-white py-2 rounded-lg font-medium disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors"
                style={{ backgroundColor: "#3D6C50" }}
              >
                {isSubmitting
                  ? i18n.language === "en"
                    ? "Submitting..."
                    : "Indsender..."
                  : i18n.language === "en"
                    ? "Send Reset Link"
                    : "Send nulstillingslink"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
